// src/context/WebsiteMonitorContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks';

const MonitorContext = createContext();

export const WebsiteMonitorProvider = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();
  
  const [sessionId, setSessionId] = useState(null);
  const [visitorId, setVisitorId] = useState(null);

  // 获取城市信息的函数（通过IP定位）
  const getCityName = async () => {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      return data.city || '未知';
    } catch (error) {
      return '未知';
    }
  };

  useEffect(() => {
    // 1. Visitor ID (持久化)
    let storedVisitorId = localStorage.getItem('wm_visitor_id');
    if (!storedVisitorId) {
      storedVisitorId = 'vid_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
      localStorage.setItem('wm_visitor_id', storedVisitorId);
    }
    setVisitorId(storedVisitorId);

    // 2. Session ID (会话级)
    let storedSessionId = sessionStorage.getItem('wm_session_id');
    if (!storedSessionId) {
      storedSessionId = 'sid_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
      sessionStorage.setItem('wm_session_id', storedSessionId);
    }
    setSessionId(storedSessionId);
  }, []);

  // 删除这个 useEffect，不需要单独更新用户映射
  // 因为后端在 /api/website/record 中会自动处理

  useEffect(() => {
    if (!sessionId || !visitorId) return;

    const sendRecord = async () => {
      const entryUrl = sessionStorage.getItem('wm_entry_url') || window.location.href;
      if (!sessionStorage.getItem('wm_entry_url')) {
        sessionStorage.setItem('wm_entry_url', window.location.href);
      }

      const currentUsername = user?.username ? user.username : 'unknowusername';
      const currentEmail = user?.email ? user.email : 'unknowemail';
      
      let cityname = sessionStorage.getItem('wm_cityname');
      if (!cityname) {
        cityname = await getCityName();
        sessionStorage.setItem('wm_cityname', cityname);
      }

      const recordData = {
        visitor_id: visitorId,
        session_id: sessionId,
        current_url: window.location.href,
        referrer_url: document.referrer,
        entry_url: entryUrl,
        user_agent: navigator.userAgent,
        username: currentUsername,
        email: currentEmail,
        cityname: cityname
      };

      const blob = new Blob([JSON.stringify(recordData)], { type: 'application/json' });
      
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/api/website/record', blob);
      } else {
        fetch('/api/website/record', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(recordData),
          keepalive: true 
        }).catch(console.error);
      }
    };

    const timer = setTimeout(sendRecord, 500);
    return () => clearTimeout(timer);
  }, [location, sessionId, visitorId, user]);

  return (
    <MonitorContext.Provider value={{ sessionId, visitorId }}>
      {children}
    </MonitorContext.Provider>
  );
};

export const useWebsiteMonitor = () => useContext(MonitorContext);